import { useCallback } from 'react';
import { useAnalytics, useScope } from 'ia-react-core';
import { useDispatch } from 'react-redux';
import { filterDocuments } from '../../../../../actions/Documents.actions';
import { DocumentsState } from '../../../../../interfaces/DocumentsState';
import { selectTypes } from '../DocumentTypeRow/selectTypes';
import { selectContracts } from '../DocumentProductRow/selectContracts';

const useHandleSubmitForm = () => {
  const { getScopedState } = useScope();

  const dispatch = useDispatch();
  const { track } = useAnalytics();

  const handleSubmitForm = useCallback(() => {
    const documentGroups = getScopedState((state: DocumentsState) => state.groups);
    const searchCriteria = getScopedState((state: DocumentsState) => state.searchCriteria);
    const documentTypes = selectTypes(documentGroups);
    const documentContracts = selectContracts(documentGroups);

    track({
      event: new MouseEvent('click'),
      scope: 'documentSearchForm',
      values:
      {
        keyword: searchCriteria?.keyword,
        period: searchCriteria?.period,
        types: documentTypes.filter((t) => searchCriteria?.type.indexOf(t.id) > -1).map((t) => t.name),
        products: documentContracts.filter((c) => searchCriteria?.product.indexOf(c.contractNumber) > -1).map((c) => c.contractName),
      },
    });

    dispatch(filterDocuments());
  }, [getScopedState, track, dispatch]);

  return handleSubmitForm;
};

export default useHandleSubmitForm;
